import { useEffect } from 'react';
//import { useLocation } from "react-router";

const TitlePage = (props) => {
  //let langue = useLocation().pathname.split('/')[2];

  let langue = 'FR'

  useEffect(() => {
    let title = '';// eslint-disable-line no-unused-vars
    switch (langue) {
      case 'EN':
        title = 'Client area';
        break;
      default:
        title = 'Espace client';
        break;
    }
    document.title = title;
  }, []);// eslint-disable-line react-hooks/exhaustive-deps
  return null;
}

export default TitlePage;